// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetCurrencies (params?: {}): Promise<implicitReturnType>;
    publicGetCurrenciesCurrency (params?: {}): Promise<implicitReturnType>;
    publicGetSymbols (params?: {}): Promise<implicitReturnType>;
    publicGetMarketOrderbookLevel1 (params?: {}): Promise<implicitReturnType>;
    publicGetMarketAllTickers (params?: {}): Promise<implicitReturnType>;
    publicGetMarketStats (params?: {}): Promise<implicitReturnType>;
    publicGetMarkets (params?: {}): Promise<implicitReturnType>;
    publicGetMarketOrderbookLevelLevelLimit (params?: {}): Promise<implicitReturnType>;
    publicGetMarketOrderbookLevel220 (params?: {}): Promise<implicitReturnType>;
    publicGetMarketOrderbookLevel2100 (params?: {}): Promise<implicitReturnType>;
    publicGetMarketHistories (params?: {}): Promise<implicitReturnType>;
    publicGetMarketCandles (params?: {}): Promise<implicitReturnType>;
    publicGetPrices (params?: {}): Promise<implicitReturnType>;
    publicGetTimestamp (params?: {}): Promise<implicitReturnType>;
    publicGetStatus (params?: {}): Promise<implicitReturnType>;
    publicGetMarkPriceSymbolCurrent (params?: {}): Promise<implicitReturnType>;
    publicGetMarkPriceAllSymbols (params?: {}): Promise<implicitReturnType>;
    publicGetMarginConfig (params?: {}): Promise<implicitReturnType>;
    publicGetAnnouncements (params?: {}): Promise<implicitReturnType>;
    publicGetMarginCollateralRatio (params?: {}): Promise<implicitReturnType>;
    publicGetConvertSymbol (params?: {}): Promise<implicitReturnType>;
    publicGetConvertCurrencies (params?: {}): Promise<implicitReturnType>;
    publicPostBulletPublic (params?: {}): Promise<implicitReturnType>;
    privateGetUserInfo (params?: {}): Promise<implicitReturnType>;
    privateGetUserApiKey (params?: {}): Promise<implicitReturnType>;
    privateGetAccounts (params?: {}): Promise<implicitReturnType>;
    privateGetAccountsAccountId (params?: {}): Promise<implicitReturnType>;
    privateGetAccountsLedgers (params?: {}): Promise<implicitReturnType>;
    privateGetHfAccountsLedgers (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginAccountLedgers (params?: {}): Promise<implicitReturnType>;
    privateGetTransactionHistory (params?: {}): Promise<implicitReturnType>;
    privateGetSubUser (params?: {}): Promise<implicitReturnType>;
    privateGetSubAccountsSubUserId (params?: {}): Promise<implicitReturnType>;
    privateGetSubAccounts (params?: {}): Promise<implicitReturnType>;
    privateGetSubApiKey (params?: {}): Promise<implicitReturnType>;
    privateGetMarginAccount (params?: {}): Promise<implicitReturnType>;
    privateGetMarginAccounts (params?: {}): Promise<implicitReturnType>;
    privateGetIsolatedAccounts (params?: {}): Promise<implicitReturnType>;
    privateGetDepositAddresses (params?: {}): Promise<implicitReturnType>;
    privateGetDeposits (params?: {}): Promise<implicitReturnType>;
    privateGetHistDeposits (params?: {}): Promise<implicitReturnType>;
    privateGetWithdrawals (params?: {}): Promise<implicitReturnType>;
    privateGetHistWithdrawals (params?: {}): Promise<implicitReturnType>;
    privateGetWithdrawalsQuotas (params?: {}): Promise<implicitReturnType>;
    privateGetAccountsTransferable (params?: {}): Promise<implicitReturnType>;
    privateGetTransferList (params?: {}): Promise<implicitReturnType>;
    privateGetBaseFee (params?: {}): Promise<implicitReturnType>;
    privateGetTradeFees (params?: {}): Promise<implicitReturnType>;
    privateGetMarketOrderbookLevelLevel (params?: {}): Promise<implicitReturnType>;
    privateGetMarketOrderbookLevel2 (params?: {}): Promise<implicitReturnType>;
    privateGetMarketOrderbookLevel3 (params?: {}): Promise<implicitReturnType>;
    privateGetHfAccountsOpened (params?: {}): Promise<implicitReturnType>;
    privateGetHfOrdersActive (params?: {}): Promise<implicitReturnType>;
    privateGetHfOrdersActiveSymbols (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOrderActiveSymbols (params?: {}): Promise<implicitReturnType>;
    privateGetHfOrdersDone (params?: {}): Promise<implicitReturnType>;
    privateGetHfOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetHfOrdersClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetHfOrdersDeadCancelAllQuery (params?: {}): Promise<implicitReturnType>;
    privateGetHfFills (params?: {}): Promise<implicitReturnType>;
    privateGetOrders (params?: {}): Promise<implicitReturnType>;
    privateGetLimitOrders (params?: {}): Promise<implicitReturnType>;
    privateGetOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetOrderClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetFills (params?: {}): Promise<implicitReturnType>;
    privateGetLimitFills (params?: {}): Promise<implicitReturnType>;
    privateGetStopOrder (params?: {}): Promise<implicitReturnType>;
    privateGetStopOrderOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetStopOrderQueryOrderByClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetOcoOrderOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetOcoOrderDetailsOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetOcoClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetOcoOrders (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOrdersActive (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOrdersDone (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOrdersClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginFills (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginStopOrders (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginStopOrderOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginStopOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOcoOrderOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOcoOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOcoOrderDetailOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetHfMarginOcoOrders (params?: {}): Promise<implicitReturnType>;
    privateGetEtfInfo (params?: {}): Promise<implicitReturnType>;
    privateGetMarginCurrencies (params?: {}): Promise<implicitReturnType>;
    privateGetRiskLimitStrategy (params?: {}): Promise<implicitReturnType>;
    privateGetIsolatedSymbols (params?: {}): Promise<implicitReturnType>;
    privateGetMarginSymbols (params?: {}): Promise<implicitReturnType>;
    privateGetIsolatedAccountSymbol (params?: {}): Promise<implicitReturnType>;
    privateGetMarginBorrow (params?: {}): Promise<implicitReturnType>;
    privateGetMarginRepay (params?: {}): Promise<implicitReturnType>;
    privateGetMarginInterest (params?: {}): Promise<implicitReturnType>;
    privateGetProjectList (params?: {}): Promise<implicitReturnType>;
    privateGetProjectMarketInterestRate (params?: {}): Promise<implicitReturnType>;
    privateGetRedeemOrders (params?: {}): Promise<implicitReturnType>;
    privateGetPurchaseOrders (params?: {}): Promise<implicitReturnType>;
    privateGetBrokerApiRebaseDownload (params?: {}): Promise<implicitReturnType>;
    privateGetBrokerQueryMyCommission (params?: {}): Promise<implicitReturnType>;
    privateGetBrokerQueryUser (params?: {}): Promise<implicitReturnType>;
    privateGetBrokerQueryDetailByUid (params?: {}): Promise<implicitReturnType>;
    privateGetMigrateUserAccountStatus (params?: {}): Promise<implicitReturnType>;
    privateGetConvertQuote (params?: {}): Promise<implicitReturnType>;
    privateGetConvertOrderDetail (params?: {}): Promise<implicitReturnType>;
    privateGetConvertOrderHistory (params?: {}): Promise<implicitReturnType>;
    privateGetConvertLimitQuote (params?: {}): Promise<implicitReturnType>;
    privateGetConvertLimitOrderDetail (params?: {}): Promise<implicitReturnType>;
    privateGetConvertLimitOrders (params?: {}): Promise<implicitReturnType>;
    privateGetAffiliateInviterStatistics (params?: {}): Promise<implicitReturnType>;
    privatePostSubUserCreated (params?: {}): Promise<implicitReturnType>;
    privatePostSubApiKey (params?: {}): Promise<implicitReturnType>;
    privatePostSubApiKeyUpdate (params?: {}): Promise<implicitReturnType>;
    privatePostDepositAddresses (params?: {}): Promise<implicitReturnType>;
    privatePostWithdrawals (params?: {}): Promise<implicitReturnType>;
    privatePostAccountsUniversalTransfer (params?: {}): Promise<implicitReturnType>;
    privatePostAccountsSubTransfer (params?: {}): Promise<implicitReturnType>;
    privatePostAccountsInnerTransfer (params?: {}): Promise<implicitReturnType>;
    privatePostTransferOut (params?: {}): Promise<implicitReturnType>;
    privatePostTransferIn (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrders (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrdersTest (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrdersSync (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrdersMulti (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrdersMultiSync (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrdersAlter (params?: {}): Promise<implicitReturnType>;
    privatePostHfOrdersDeadCancelAll (params?: {}): Promise<implicitReturnType>;
    privatePostOrders (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersTest (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersMulti (params?: {}): Promise<implicitReturnType>;
    privatePostStopOrder (params?: {}): Promise<implicitReturnType>;
    privatePostOcoOrder (params?: {}): Promise<implicitReturnType>;
    privatePostHfMarginOrder (params?: {}): Promise<implicitReturnType>;
    privatePostHfMarginOrderTest (params?: {}): Promise<implicitReturnType>;
    privatePostHfMarginStopOrder (params?: {}): Promise<implicitReturnType>;
    privatePostMarginOrder (params?: {}): Promise<implicitReturnType>;
    privatePostMarginOrderTest (params?: {}): Promise<implicitReturnType>;
    privatePostHfMarginOcoOrder (params?: {}): Promise<implicitReturnType>;
    privatePostMarginBorrow (params?: {}): Promise<implicitReturnType>;
    privatePostMarginRepay (params?: {}): Promise<implicitReturnType>;
    privatePostPurchase (params?: {}): Promise<implicitReturnType>;
    privatePostRedeem (params?: {}): Promise<implicitReturnType>;
    privatePostLendPurchaseUpdate (params?: {}): Promise<implicitReturnType>;
    privatePostConvertOrder (params?: {}): Promise<implicitReturnType>;
    privatePostConvertLimitOrder (params?: {}): Promise<implicitReturnType>;
    privatePostBulletPrivate (params?: {}): Promise<implicitReturnType>;
    privatePostPositionUpdateUserLeverage (params?: {}): Promise<implicitReturnType>;
    privatePostDepositAddressCreate (params?: {}): Promise<implicitReturnType>;
    privateDeleteSubApiKey (params?: {}): Promise<implicitReturnType>;
    privateDeleteWithdrawalsWithdrawalId (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrdersSyncOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrdersClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrdersSyncClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrdersCancelOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfOrdersCancelAll (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrderClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteStopOrderOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteStopOrderCancelOrderByClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteStopOrderCancel (params?: {}): Promise<implicitReturnType>;
    privateDeleteOcoOrderOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteOcoClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteOcoOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginOrdersClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginStopOrderCancelById (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginStopOrderCancelByClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginStopOrderCancel (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginOcoOrderCancelById (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginOcoOrderCancelByClientOid (params?: {}): Promise<implicitReturnType>;
    privateDeleteHfMarginOcoOrderCancel (params?: {}): Promise<implicitReturnType>;
    privateDeleteConvertLimitOrderCancel (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetContractsActive (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetContractsSymbol (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetTicker (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetAllTickers (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetLevel2Snapshot (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetLevel2Depth20 (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetLevel2Depth100 (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetTradeHistory (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetKlineQuery (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetInterestQuery (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetIndexQuery (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetMarkPriceSymbolCurrent (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetPremiumQuery (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetTradeStatistics (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetFundingRateSymbolCurrent (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetContractFundingRates (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetTimestamp (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetStatus (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetLevel2MessageQuery (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetContractsRiskLimitSymbol (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetLevel3MessageQuery (params?: {}): Promise<implicitReturnType>;
    futuresPublicGetLevel3Snapshot (params?: {}): Promise<implicitReturnType>;
    futuresPublicPostBulletPublic (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetTransactionHistory (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetAccountOverview (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetAccountOverviewAll (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetTransferList (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetStopOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetRecentDoneOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetOrdersByClientOid (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetFills (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetRecentFills (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetTradeFees (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetOpenOrderStatistics (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetPosition (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetPositions (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetMarginMaxWithdrawMargin (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetContractsRiskLimitSymbol (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetFundingHistory (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetCopyTradeFuturesGetMaxOpenSize (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetCopyTradeFuturesPositionMarginMaxWithdrawMargin (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetHistoryPositions (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetPositionGetMarginMode (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetPositionGetPositionMode (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetDepositAddress (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetDepositList (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetWithdrawalsQuotas (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetWithdrawalList (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetSubApiKey (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetTradeStatistics (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetGetMaxOpenSize (params?: {}): Promise<implicitReturnType>;
    futuresPrivateGetGetCrossUserLeverage (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostTransferOut (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostTransferIn (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostStOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostOrdersTest (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostOrdersMulti (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostPositionMarginAutoDepositStatus (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostMarginWithdrawMargin (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostPositionMarginDepositMargin (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostPositionRiskLimitLevelChange (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesOrdersTest (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesStOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesPositionMarginDepositMargin (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesPositionMarginWithdrawMargin (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesPositionRiskLimitLevelChange (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesPositionMarginAutoDepositStatus (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesPositionChangeMarginMode (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeFuturesPositionChangeCrossUserLeverage (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradeGetCrossModeMarginRequirement (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostCopyTradePositionSwitchPositionMode (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostChangeCrossUserLeverage (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostWithdrawals (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostSubApiKey (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostSubApiKeyUpdate (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostPositionChangeMarginMode (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostPositionSwitchPositionMode (params?: {}): Promise<implicitReturnType>;
    futuresPrivatePostBulletPrivate (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteOrdersClientOrderClientOid (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteStopOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteCopyTradeFuturesOrders (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteCopyTradeFuturesOrdersClientOrder (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteOrdersMultiCancel (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteWithdrawalsWithdrawalId (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteCancelTransferOut (params?: {}): Promise<implicitReturnType>;
    futuresPrivateDeleteSubApiKey (params?: {}): Promise<implicitReturnType>;
    webExchangeGetCurrencyCurrencyChainInfo (params?: {}): Promise<implicitReturnType>;
    webExchangeGetContractSymbolFundingRates (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdInfo (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdAccount (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdAccountApikey (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdRebaseDownload (params?: {}): Promise<implicitReturnType>;
    brokerGetAssetNdbrokerDepositList (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdTransferDetail (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdDepositDetail (params?: {}): Promise<implicitReturnType>;
    brokerGetBrokerNdWithdrawDetail (params?: {}): Promise<implicitReturnType>;
    brokerPostBrokerNdTransfer (params?: {}): Promise<implicitReturnType>;
    brokerPostBrokerNdAccount (params?: {}): Promise<implicitReturnType>;
    brokerPostBrokerNdAccountApikey (params?: {}): Promise<implicitReturnType>;
    brokerPostBrokerNdAccountUpdateApikey (params?: {}): Promise<implicitReturnType>;
    brokerDeleteBrokerNdAccountApikey (params?: {}): Promise<implicitReturnType>;
    earnGetOtcLoanDiscountRateConfigs (params?: {}): Promise<implicitReturnType>;
    earnGetOtcLoanLoan (params?: {}): Promise<implicitReturnType>;
    earnGetOtcLoanAccounts (params?: {}): Promise<implicitReturnType>;
    earnGetEarnRedeemPreview (params?: {}): Promise<implicitReturnType>;
    earnGetEarnSavingProducts (params?: {}): Promise<implicitReturnType>;
    earnGetEarnHoldAssets (params?: {}): Promise<implicitReturnType>;
    earnGetEarnPromotionProducts (params?: {}): Promise<implicitReturnType>;
    earnGetEarnKcsStakingProducts (params?: {}): Promise<implicitReturnType>;
    earnGetEarnStakingProducts (params?: {}): Promise<implicitReturnType>;
    earnGetEarnEthStakingProducts (params?: {}): Promise<implicitReturnType>;
    earnGetStructEarnDualProducts (params?: {}): Promise<implicitReturnType>;
    earnGetStructEarnOrders (params?: {}): Promise<implicitReturnType>;
    earnPostEarnOrders (params?: {}): Promise<implicitReturnType>;
    earnPostStructEarnOrders (params?: {}): Promise<implicitReturnType>;
    earnDeleteEarnOrders (params?: {}): Promise<implicitReturnType>;
    utaGetMarketAnnouncement (params?: {}): Promise<implicitReturnType>;
    utaGetMarketCurrency (params?: {}): Promise<implicitReturnType>;
    utaGetAssetCurrencies (params?: {}): Promise<implicitReturnType>;
    utaGetMarketInstrument (params?: {}): Promise<implicitReturnType>;
    utaGetMarketTicker (params?: {}): Promise<implicitReturnType>;
    utaGetMarketTrade (params?: {}): Promise<implicitReturnType>;
    utaGetMarketKline (params?: {}): Promise<implicitReturnType>;
    utaGetMarketFundingRate (params?: {}): Promise<implicitReturnType>;
    utaGetMarketFundingRateHistory (params?: {}): Promise<implicitReturnType>;
    utaGetMarketCrossConfig (params?: {}): Promise<implicitReturnType>;
    utaGetMarketCollateralDiscountRatio (params?: {}): Promise<implicitReturnType>;
    utaGetMarketIndexPrice (params?: {}): Promise<implicitReturnType>;
    utaGetMarketPositionTiers (params?: {}): Promise<implicitReturnType>;
    utaGetMarketOpenInterest (params?: {}): Promise<implicitReturnType>;
    utaGetServerStatus (params?: {}): Promise<implicitReturnType>;
    utaGetMarketBorrowableCurrency (params?: {}): Promise<implicitReturnType>;
    utaGetUserMyIp (params?: {}): Promise<implicitReturnType>;
    utaGetMarketFiatPrice (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetMarketOrderbook (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountBalance (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountTransferQuota (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountMode (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountLedger (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountInterestHistory (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAssetDepositAddress (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountDepositAddress (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModeAccountBalance (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModeAccountOverview (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModeOrderDetail (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModeOrderOpenList (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModeOrderHistory (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModeOrderExecution (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModePositionOpenList (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModePositionHistory (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetPositionHistory (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountModePositionTiers (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetSubAccountBalance (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetUserFeeRate (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetDcpQuery (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetUnifiedAccountLeverage (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetPositionFundingHistory (params?: {}): Promise<implicitReturnType>;
    utaPrivateGetAccountInterestLimits (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountTransfer (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountMode (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeAccountModifyLeverage (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeOrderPlace (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeOrderPlaceBatch (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeOrderCancel (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeOrderCancelBatch (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeOrderCancelAll (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostSubAccountCanTransferOut (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostDcpSet (params?: {}): Promise<implicitReturnType>;
    utaPrivatePostAccountModeAccountModifyLeverageMarginCross (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
